<template>
 <div id="mainbox" style="padding:34px;background-color:#F1F4FA;height:calc(100vh - 51px);box-sizing: border-box;">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 39px;">
      <el-breadcrumb-item v-for="(item,key) in breadcrumb" :key="key" :to="{ name: item.path }">{{ item.name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div style="background-color:#fff;overflow: hidden;padding: 0 36px;text-align:left">
      <div style="text-align:left;margin:18px 0;">查询</div>
      <div class="formBox" style=" background: #FFFFFF;border: 2px solid #DCDFE6;display: inline-block;">
      <el-form :inline="true" style="text-align:left;" :model="formInline"
        class="demo-form-inline">
        <el-form-item label="姓名">
          <el-input style="width:200px" v-model="formInline.sn" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input style="width:200px" v-model="formInline.iccid" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="currentPage=1;getList()">查询</el-button>
          <el-button  @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
      <div>
        <div style="display:flex;justify-content: space-between;align-items: center;">
          <div style="display:flex;width:180px;">
            <div @click="chooseIndex=1" :class="chooseIndex==1&&'choosed'" style="border-bottom:1px solid #FFFFFF;padding:10px 0;cursor: pointer;margin-right:20px;">启用</div>
            <div @click="chooseIndex=2" :class="chooseIndex==2&&'choosed'" style="border-bottom:1px solid #FFFFFF;padding:10px 0;cursor: pointer;">禁用</div>
          </div>
          <el-button type="primary" style="margin-right:20px;margin-bottom:20px">新建</el-button>
        </div>
        <el-table :data="tableData" border style="width: 100%;margin-top:20px">
          <el-table-column prop="nickname" label="姓名">
          </el-table-column>
          <el-table-column prop="username" label="账号">
          </el-table-column>
          <el-table-column prop="phone" label="手机号">
          </el-table-column>
          <el-table-column prop="online" label="角色">
            <template slot-scope="scope">
              <span>{{scope.row.online|onlineFilters}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="添加时间">
          </el-table-column>
          <el-table-column prop="postCount" label="状态">
          </el-table-column>
          <el-table-column fixed="right" label="操作" >
            <!-- <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">详情</el-button>
            </template> -->
          </el-table-column>
        </el-table>
        <div style="text-align:center">
          <el-pagination style="margin:20px 0" 
          @size-change="handleSizeChange"
          :page-size="pageSize" :current-page="currentPage"
            @current-change="handleCurrentChange" layout="total, prev, pager, next,sizes, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="新建账号" width="50%" :close-on-click-modal="false" @close="form= {
        name:'',
        remark: '',
      }" :visible.sync="dialogVisible">
      <div style="display:flex;">
        <el-form ref="form" style="width:50vw;" :model="form" label-width="120px"
          @submit.native.prevent>
          <el-form-item label="箱号：">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.remark"  type="textarea" :autosize="{ minRows:8, maxRows: 10}"></el-input>
          </el-form-item>
          <el-form-item label="" style="text-align:right">
            <el-button @click="dialogVisible=false">取 消</el-button>
            <el-button type="primary" @click="commit">确 认</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data () {
      return {
        breadcrumb:[{name:'账号管理'}],
        dialogVisible: false,
        tableData: [],
        qrcode: '', 
        formInline: { sn: '', date: '', iccid: '', imei: '', status: -1, fw_version:-1 },
        currentPage: 1,
        form: {
          name: '',
          remark: '',
        },
        lists: [],
        loading: '',
        listtimeout: '',
        pageSize:10,
        total: 0,
        chooseIndex:1
      }
    },    
    filters: {
    onlineFilters(val) {
     switch (val) {
      case 0:
        return'从未上线'
      case 1:
        return'在线'
      case 2:
        return'不在线'
     }
    },
  },
    methods: {
      handleSizeChange(e){
        this.pageSize=e
        this.getList()
      },
      commit () {
        if(!this.form.name){
          this.$message({
            message: '箱号名称不能为空',
            type: 'warning'
          });
          return
        }
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$axios.post('/admin/box/create', {
          name:this.form.name,
          remark: this.form.remark
        }).then((response) => {
          loading.close()
          console.info(response)
          this.dialogVisible = false
          this.getList()
        }, err => {
          loading.close()
          if(err.data){
            this.$message.error(err.data.message);
          }
        })
      },
      handleClick (e) {
        console.info(e)
        this.$router.push({ path: "/boxDetail",  query: {data: e}})
      },
      reset () {
        this.currentPage = 1
        this.formInline = { sn: '', date: '', iccid: '', imei: '', status: -1, fw_version:-1 }
        this.getList()
      },
      handleCurrentChange (e) {
        this.currentPage = e
        this.getList()
      },
      getList () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$axios.post('/admin/users/list', {
          page: this.currentPage,
          per_page: this.pageSize,
        }).then((response) => {
          loading.close()
          this.tableData = response.data.users
          this.total = response.data.total_count
          console.info(response)
          document.getElementById('mainbox').scrollTop = 0;
        }, err => {
          if(err.data){
            this.$message.error(err.data.message);
          }
          loading.close()
        })
      }

    },
    mounted () {
      this.getList()
    }
  }
</script>

<style>
  body {
    margin: 0;
  }


  .choosed{border-bottom:1px solid #409EFF !important;}
</style>